<template>
    <div class="option">
        <div class="option-wrapper">
            <div class="text-wrapper">
                <div class="text-wrapper-inpt">
                    <v-text-field
                        :label="label"
                        v-model="optionLabel"
                        :counter="max"
                        :maxlength="max"
                        @change="updateOptionText($event)"
                    ></v-text-field>
                </div>
            </div>

            <div class="option-actions">
                <button
                    :class="`${hasAdvancedConfig ? 'open' : ''}`"
                    @click="toogleAdvancedConfig"
                >
                    <i class="mdi mdi-settings pointer"></i>
                </button>

                <i
                    class="mdi mdi-close-circle-outline"
                    v-tooltip="$t('message.campaigns.message.deleteOption')"
                    @click="$emit('remove')"
                ></i>
            </div>
        </div>

        <div v-if="showAdvancedConfig" class="advanced-config">
            <v-text-field
                v-if="!hasNextInteractionId"
                :label="$t('message.campaigns.message.postAuthPage')"
                v-model="postAuthUrl"
                @change="updatePostAuthUrl"
            ></v-text-field>

            <IntegrationLinkCheckbox
                :value="value.integrationTrigger"
                center
                @select="linkIntegration"
            />
        </div>
    </div>
</template>

<script>
import IntegrationLinkCheckbox from "@/components/integration/IntegrationLinkCheckbox.vue";
import EventBus from "@packages/event-bus";

export default {
    components: {
        IntegrationLinkCheckbox,
    },
    data() {
        return {
            max: 24,
            optionValue: this.value.nome,
            postAuthUrl: this.value ? this.value.paginaPosAutenticacao : "",
            showAdvancedConfig: false,
        };
    },

    props: {
        dataIndex: {
            type: Number,
            required: true,
        },

        value: {
            type: Object,
            required: true,
        },

        interaction: {
            type: Object,
            required: true,
        },
    },

    computed: {
        label() {
            return `${this.$t("message.campaigns.message.option")} ${
                this.dataIndex
            }`;
        },
        hasAdvancedConfig() {
            return (
                this.value &&
                (this.value.paginaPosAutenticacao ||
                    this.value.integrationTrigger)
            );
        },
        hasNextInteractionId() {
            return !!this.value.proximaInteracaoId;
        },
        optionLabel: {
            get() {
                return this.value.nome;
            },
            set() {
                return;
            },
        },
    },

    methods: {
        updateOptionText(evt) {
            if (evt.length <= 1) {
                return EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.optionTwoCharacters"
                    ),
                });
            }

            this.$emit("change", evt);
        },
        async linkIntegration(integrationId) {
            try {
                if (integrationId) {
                    await this.$api.interactions.options.linkIntegration({
                        optionId: this.value.id,
                        interactionId: this.interaction.id,
                        advertisingId: this.interaction.campanhaId,
                        integrationId,
                    });
                } else {
                    await this.$api.interactions.options.unlinkIntegration({
                        optionId: this.value.id,
                        interactionId: this.interaction.id,
                        advertisingId: this.interaction.campanhaId,
                    });
                }

                this.$emit("reload");
            } catch (error) {
                console.log(error);
            }
        },
        updatePostAuthUrl(evt) {
            this.$emit("change-auth", evt);
        },
        toogleAdvancedConfig() {
            this.showAdvancedConfig = !this.showAdvancedConfig;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.option {
    .option-wrapper {
        display: flex;
        //align-items: center;
        justify-content: space-between;
        margin-bottom: -4px;
        align-items: flex-start;

        .text-wrapper {
            width: 80%;
        }

        button {
            margin-right: 5px;
            &.open {
                color: $primary;
            }
        }

        .mdi {
            margin-bottom: 4px;
            font-size: 16px;
            cursor: pointer;
        }
    }

    .advanced-config {
        background: #f6f6f6;
        margin: 5px -15px;
        padding: 5px 15px;
    }
}
</style>
